import React, { useEffect, useState } from 'react';
import { Check, XCircle, Info } from 'lucide-react';

type Toast = { id: number; message: string; type: 'success' | 'error' | 'info' };

const ToastContainer: React.FC = () => {
  const [toast, setToast] = useState<Toast | null>(null);

  useEffect(() => {
    const handler = (e: any) => {
      const { message, type } = e.detail || {};
      if (!message) return;
      setToast({ id: Date.now(), message, type: type || 'success' });
      setTimeout(() => setToast(null), 3500);
    };
    window.addEventListener('app:toast', handler as EventListener);
    return () => window.removeEventListener('app:toast', handler as EventListener);
  }, []);

  if (!toast) return null;

  return (
    <div className="fixed top-4 right-4 z-50 animate-fade-in-up">
      <div className={`px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 border transition-all ${toast.type === 'success' ? 'bg-green-600 dark:bg-green-500 text-white border-green-700' : toast.type === 'error' ? 'bg-red-600 text-white border-red-700' : 'bg-brand-500 text-white border-blue-700'}`}>
        <div className="rounded-full p-1 bg-white/20">
          {toast.type === 'success' ? <Check className="w-4 h-4 text-white" /> : toast.type === 'error' ? <XCircle className="w-4 h-4 text-white" /> : <Info className="w-4 h-4 text-white" />}
        </div>
        <div className="flex flex-col">
          <span className="font-semibold text-xs opacity-90">{toast.type === 'success' ? 'Sucesso' : toast.type === 'error' ? 'Erro' : 'Info'}</span>
          <span className="text-sm font-medium">{toast.message}</span>
        </div>
      </div>
    </div>
  );
};

export default ToastContainer;
